import React from 'react';
import { useCustomMediaQuery } from '../../../../../../../submodules/web-shared/hooks/mediaQuery';
import { Attachment } from '../../../..';
import MobileView from './components/MobileView';
import DesktopView from './components/DesktopView';

export interface DialogContentProps<T extends Attachment, > {
  activeAttachment: T;
  handleClose: () => void;
  AttachmentDetails?: React.ElementType;
}

const DialogContent = <T extends Attachment, >({ activeAttachment, handleClose, AttachmentDetails }: DialogContentProps<T>) => {
  const isMobileView = useCustomMediaQuery('down', 'lg');

  return (
    <>
      {isMobileView ?
        <MobileView
          handleClose={handleClose}
          activeAttachment={activeAttachment}
          AttachmentDetails={AttachmentDetails}
        /> :
        <DesktopView
          handleClose={handleClose}
          activeAttachment={activeAttachment}
          AttachmentDetails={AttachmentDetails}
        />
      }
    </>
  );
};

export default DialogContent;